import { Component, OnInit, Input } from '@angular/core';
import { MainPageService } from '../../main-page.service';
import { InteractionEquationModel } from '../../../models/dictionaries/interaction-equation.model';
import { KatexOptions } from 'ng-katex';
import { EquationParser } from '../../../shared/equation-parser/equation-parser';

declare var $: any;


@Component({
  selector: 'app-interaction-equations-grid',
  template: `<!-- Create Modal -->
<div class="modal" id="addInteractionEquationModal">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body display-flex">
                <div>
                    <div class="display-flex">
                        <span class="modal-label">Name:</span>
                        <input type="text" [(ngModel)]="editedInteractionEquation.name" #ctrl2="ngModel" required>
                    </div>
                    <div class="display-flex">
                        <span class="modal-label">Code based:</span>
                        <input type="checkbox" [(ngModel)]="editedInteractionEquation.codeBased">
                    </div>
                    <div class="display-flex">
                        <span class="modal-label">Equation:</span>
                        <input type="text" #equation1 [(ngModel)]="editedInteractionEquation.equation" (keyup)="onChange(equation1.value)">
                    </div>
                    <div class="display-flex">
                        <span class="modal-label">Visual:</span>
                        <ng-katex class="equation-overflow" [equation]="convertedEquation" [options]="options"></ng-katex>
                    </div>
                    <div>
                        <br>
                        <b>Allowed input for the equations:</b>
                        <ul>
                            <li>Mathematical operators +, -. *, /, ^, min(), max(), sin(), cos(), tan</li>
                            <li>Numbers</li>
                            <li>Design Load/Moment Fa.ed, Fx.ed, Fy.ed, Fz.ed, Mx.ed, My.ed, Mz.ed, X</li>
                            <li>Resistance Load/Moment Fx.ed, Fy.rd, Fz.rd, Mx.rd, My.rd, Mz.rd</li>
                            <li>Codes" N, V, MAX, VX, NX, N2+N5, N2+N5_MAX, F1, F2, F3, N2, N3, V2</li>
                            <li>You can enter multiple equations if you separate them by ;</li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="ctrl2.invalid" (click)="saveNewInteractionEquation()">Save</button>
            </div>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this interaction equation?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deleteInteractionEquation(editedInteractionEquation)">Delete</button>
            </div>
        </div>
    </div>
</div>

<!-- Edit Modal -->
<div class="modal" id="editModal">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body display-flex">
                <div>
                    <div class="display-flex">
                        <span class="modal-label">Name:</span>
                        <input type="text" [(ngModel)]="editedInteractionEquation.name" #ctrl="ngModel" required>
                    </div>
                    <div class="display-flex">
                        <span class="modal-label">Code based:</span>
                        <input type="checkbox" [(ngModel)]="editedInteractionEquation.codeBased">
                    </div>
                    <div class="display-flex">
                        <span class="modal-label">Equation:</span>
                        <input type="text" #equation2 [(ngModel)]="editedInteractionEquation.equation" (keyup)="onChange(equation2.value)">
                    </div>
                    <div class="display-flex">
                        <span class="modal-label">Visual:</span>
                        <ng-katex class="equation-overflow" [equation]="convertedEquation" [options]="options"></ng-katex>
                    </div>
                    <div>
                        <br>
                        <b>Allowed input for the equations:</b>
                        <ul>
                            <li>Mathematical operators +, -. *, /, ^, min(), max(), sin(), cos(), tan</li>
                            <li>Numbers</li>
                            <li>Design Load/Moment Fa.ed, Fx.ed, Fy.ed, Fz.ed, Mx.ed, My.ed, Mz.ed, X</li>
                            <li>Resistance Load/Moment Fx.ed, Fy.rd, Fz.rd, Mx.rd, My.rd, Mz.rd</li>
                            <li>Codes" N, V, MAX, VX, NX, N2+N5, N2+N5_MAX, F1, F2, F3, N2, N3, V2</li>
                            <li>You can enter multiple equations if you separate them by ;</li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="ctrl.invalid" (click)="editInteractionEquation()">Save</button>
            </div>
        </div>
    </div>
</div>


<div class="input-effect">
    <input class="effect1" type="text" placeholder="">
    <label>Search</label>
    <span class="focus-border"></span>
</div>
<button class="red-button" type="button" data-toggle="modal" data-target="#addInteractionEquationModal" (click)="setChoosenElement(null, -1)">Create</button>

<table>
    <tr>
        <th *ngFor="let header of headers">{{header}}</th>
    </tr>
    <tr *ngFor="let interactionEquation of interactionEquationsGridData, let row_no = index">
        <td>{{interactionEquation.name}}</td>
        <td>
            <input type="checkbox" [ngModel]="interactionEquation.codeBased" disabled>
        </td>
        <td>{{interactionEquation.equation}}</td>
        <td class="columnWithIcons">
            <button type="button" class="btn editBtn" data-toggle="modal" data-target="#editModal" (click)="setChoosenElement(interactionEquation, row_no)">
                <i class="fa fa-edit"></i>
            </button>
            <button type="button" class="btn deleteBtn" data-toggle="modal" data-target="#deleteModal" (click)="setChoosenElement(interactionEquation, row_no)">
                <i class="fa fa-trash"></i>
            </button>
        </td>
    </tr>
</table>`,
  styles: [`ng-katex{font-size:1.1em}.equation-overflow{max-width:650px;overflow-x:auto}table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:110px}.display-flex{display:flex;align-items:center;margin-bottom:10px;margin-right:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}.rectangle{width:200px;height:100px;border:1px solid gray}`]
})
export class InteractionEquationsComponent implements OnInit {
  converter = new EquationParser();
  isInteractionEquationsHidden = true;
  interactionEquationsGridData: InteractionEquationModel[];
  editedInteractionEquation = new InteractionEquationModel();
  convertedEquation: string;
  rowNumber: number;
  options: KatexOptions = {
    displayMode: true,
  };
  headers: string[] = ['Name', 'Code based', 'Equation', ''];

  constructor(private mainPageService: MainPageService) { }

  public ngOnInit(): void {
    this.loadGridDataFromDb();
    this.mainPageService.deleteInteractionEquationSubject.subscribe((value) => {
      this.interactionEquationsGridData = this.interactionEquationsGridData.filter(x => x._id !== value);
    });
  }

  loadGridDataFromDb() {
    this.mainPageService.loadAllInteracionEquations().subscribe((response) => {
      this.interactionEquationsGridData = response.sort(function (a, b) {
        return (a.name < b.name) ? -1 : 1;
      });
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
      $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isInteractionEquationsHidden = !this.isInteractionEquationsHidden;
  }

  saveNewInteractionEquation() {
    this.mainPageService.addNewInteracionEquationIntoDb(JSON.stringify(this.editedInteractionEquation)).subscribe((response) => {
      this.editedInteractionEquation._id = response;
      this.interactionEquationsGridData.push(this.editedInteractionEquation);
      this.editedInteractionEquation = new InteractionEquationModel();
    });
  }

  setChoosenElement(element: InteractionEquationModel, row) {
    if (row === -1) {
      this.editedInteractionEquation = new InteractionEquationModel();
      this.convertedEquation = "";
    } else {
      this.editedInteractionEquation = {
        ...element,
      };
      this.convertedEquation = this.converter.convertEquationToLatex(this.editedInteractionEquation.equation);
      this.rowNumber = row;
    }
  }

  editInteractionEquation() {
    console.log(this.interactionEquationsGridData[this.rowNumber]);
    Object.assign(this.interactionEquationsGridData[this.rowNumber], this.editedInteractionEquation);
    this.mainPageService.updateInteractionEquationInDb(JSON.stringify(this.editedInteractionEquation)).subscribe((response) => { });
  }

  deleteInteractionEquation(interactionEquation) {
    this.mainPageService.removeInteracionEquation(interactionEquation._id).subscribe((res) => { }, (error: any) => { });
    this.mainPageService.deleteInteractionEquationSubject.next(interactionEquation._id);
  }

  onChange(event) {
    this.convertedEquation = this.converter.convertEquationToLatex(event);
  }
}
